import tokens from './tokens'
import { SerializedFarmConfig } from './types'

const priceHelperLps: SerializedFarmConfig[] = [
  /**
   * These LPs are just used to help with price calculation for MasterChef LPs (farms.ts).
   * This list is added to the MasterChefLps and passed to fetchFarm. The calls to get contract information about the token/quoteToken in the LP are still made.
   * The absense of a PID means the masterchef contract calls are skipped for this farm.
   * Prices are then fetched for all farms (masterchef + priceHelperLps).
   * Before storing to redux, farms without a PID are filtered out.
   */
  // {
  //   pid: null,
  //   lpSymbol: 'QSD-BNB LP',
  //   lpAddresses: {
  //     10001: '',
  //     10000: '0xe3897cdd1a3e9c5634f1cedb6794f0d7ba6c26f4',
  //   },
  //   token: tokens.qsd,
  //   quoteToken: tokens.wbnb,
  // },
  // FIXME: What the ACTUAL FUCK is this? It kept everything from loading!
]

export default priceHelperLps
